var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"ds-chip",class:[
    ("ds-chip-size-" + _vm.size),
    ("ds-chip-" + _vm.color),
    _vm.removable && 'ds-chip-removable',
    _vm.round && 'ds-chip-round'
  ]},[_vm._t("default"),(_vm.removable)?_c('button',{staticClass:"ds-chip-close",attrs:{"tabindex":"-1"},on:{"click":_vm.remove}},[_c('ds-icon',{attrs:{"name":"close"}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }